/* Shop the Look — modal open/close, size picker, AJAX add (stay open).
   Modeled on fbt-quick-add.js. No dependencies. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var body = document.body;

    // The modal is rendered inside the product media gallery (.vz-mgallery),
    // which has a tap-to-zoom handler on touchend. Any tap inside the modal
    // bubbles up to it. Relocate each modal to <body> so it's no longer a
    // descendant of the gallery — taps in the popup can't trigger zoom.
    document.querySelectorAll('.vz-stl-modal, .vz-stl-sg').forEach(function (el) {
      if (el.parentNode !== body) body.appendChild(el);
    });

    /* ---------- open / close ---------- */
    function openModal(modal) {
      if (!modal) return;
      modal.hidden = false;
      body.classList.add('vz-stl-lock');
      var x = modal.querySelector('[data-vz-stl-close]');
      if (x) x.focus();
    }
    function closeModal(modal) {
      if (!modal) return;
      modal.hidden = true;
      body.classList.remove('vz-stl-lock');
      // collapse any open pickers
      modal.querySelectorAll('.vz-stl-picker.is-open').forEach(function (p) {
        p.classList.remove('is-open');
        var t = p.querySelector('[data-vz-stl-toggle]');
        var l = p.querySelector('.vz-stl-sizes');
        if (t) t.setAttribute('aria-expanded', 'false');
        if (l) l.hidden = true;
      });
    }

    document.querySelectorAll('[data-vz-stl-open]').forEach(function (btn) {
      // the pill sits inside the product media gallery, which has a tap-to-zoom
      // handler on touchend. Stop the pill's touch/click from bubbling so tapping
      // it opens the modal without also toggling the gallery zoom.
      var stop = function (e) { e.stopPropagation(); };
      btn.addEventListener('touchstart', stop, { passive: true });
      btn.addEventListener('touchend', stop);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        openModal(document.getElementById(btn.getAttribute('aria-controls')));
      });
    });

    document.querySelectorAll('.vz-stl-modal').forEach(function (modal) {
      modal.querySelectorAll('[data-vz-stl-close]').forEach(function (el) {
        el.addEventListener('click', function () { closeModal(modal); });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var sgOpen = document.querySelector('.vz-stl-sg:not([hidden])');
      if (sgOpen) { closeSizeChart(sgOpen); return; }
      var open = document.querySelector('.vz-stl-modal:not([hidden])');
      if (open) closeModal(open);
    });

    /* ---------- size picker (chevron) ---------- */
    document.querySelectorAll('[data-vz-stl-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var picker = toggle.closest('[data-vz-stl-picker]');
        if (!picker) return;
        var list = picker.querySelector('.vz-stl-sizes');
        var isOpen = picker.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (list) list.hidden = !isOpen;
      });
    });

    /* ---------- size chart (panels are pre-rendered in Liquid) ---------- */
    function closeSizeChart(sg) {
      if (!sg) return;
      sg.hidden = true;
      // the modal stays open behind it, so only drop the lock if it isn't
      if (!document.querySelector('.vz-stl-modal:not([hidden])')) {
        body.classList.remove('vz-stl-lock');
      }
    }

    document.querySelectorAll('[data-vz-stl-sg-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        // pair the overlay to this card's own section: vzStl-x -> vzStlSg-x
        var modal = btn.closest('.vz-stl-modal');
        var sg = (modal && document.getElementById(modal.id.replace('vzStl-', 'vzStlSg-')))
              || document.querySelector('.vz-stl-sg');
        if (!sg) return;
        var id = btn.getAttribute('data-vz-stl-sg-open');
        var found = false;
        sg.querySelectorAll('[data-vz-stl-sg-panel]').forEach(function (panel) {
          var match = panel.getAttribute('data-vz-stl-sg-panel') === id;
          panel.hidden = !match;
          if (match) found = true;
        });
        if (!found) return;
        sg.hidden = false;
        sg.scrollTop = 0;
        body.classList.add('vz-stl-lock');
        var x = sg.querySelector('[data-vz-stl-sg-close]');
        if (x) x.focus();
      });
    });

    document.querySelectorAll('.vz-stl-sg').forEach(function (sg) {
      sg.querySelectorAll('[data-vz-stl-sg-close]').forEach(function (el) {
        el.addEventListener('click', function () { closeSizeChart(sg); });
      });
    });

    /* a tap anywhere else in the modal collapses an open size drawer, so the
       drawer is never a dead end even if the Add to Bag bar is missed */
    document.querySelectorAll('.vz-stl-modal').forEach(function (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-vz-stl-picker]')) return;
        modal.querySelectorAll('.vz-stl-picker.is-open').forEach(function (p) {
          p.classList.remove('is-open');
          var t = p.querySelector('[data-vz-stl-toggle]');
          var l = p.querySelector('.vz-stl-sizes');
          if (t) t.setAttribute('aria-expanded', 'false');
          if (l) l.hidden = true;
        });
      });
    });

    /* ---------- add to cart (AJAX, stay open) ---------- */
    document.querySelectorAll('[data-vz-stl-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-variant-id');
        if (!id || btn.disabled) return;
        addToCart(id, btn);
      });
    });

    function addToCart(variantId, btn) {
      var barBtn = btn.classList.contains('vz-stl-size')
        ? btn.closest('.vz-stl-picker').querySelector('.vz-stl-add')
        : btn;
      var label = barBtn.querySelector('span');
      var prev = label ? label.textContent : '';
      if (label) label.textContent = 'Adding…';
      barBtn.disabled = true;

      // ask Shopify to also return the cart-drawer + icon-bubble section HTML,
      // so we update the theme's real cart (fixes "cart looks empty").
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (state.status === 422 || state.status === 404) {
            throw new Error(state.description || 'add failed');
          }
          // stay in modal; reflect success on the bar, collapse picker
          barBtn.classList.add('is-added');
          if (label) label.textContent = 'Added ✓';
          var picker = barBtn.closest('.vz-stl-picker');
          if (picker) {
            picker.classList.remove('is-open');
            var t = picker.querySelector('[data-vz-stl-toggle]');
            var l = picker.querySelector('.vz-stl-sizes');
            if (t) t.setAttribute('aria-expanded', 'false');
            if (l) l.hidden = true;
          }
          updateCartSections(state.sections);
          setTimeout(function () {
            barBtn.classList.remove('is-added');
            barBtn.disabled = false;
            if (label) label.textContent = prev;
          }, 1800);
        })
        .catch(function () {
          if (label) label.textContent = 'Try again';
          barBtn.disabled = false;
          setTimeout(function () { if (label) label.textContent = prev; }, 1800);
        });
    }

    /* ---------- update the theme's cart drawer + icon WITHOUT opening it ----------
       Mirrors cart-drawer.js renderContents but skips .open() so our modal stays up. */
    function updateCartSections(sections) {
      if (!sections) return;

      // cart-drawer body: swap #CartDrawer inner + clear the is-empty states
      if (sections['cart-drawer']) {
        var dDoc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var freshInner = dDoc.querySelector('#CartDrawer');
        var liveInner = document.querySelector('#CartDrawer');
        if (freshInner && liveInner) liveInner.innerHTML = freshInner.innerHTML;
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) drawerEl.classList.remove('is-empty');
        var inner = document.querySelector('cart-drawer .drawer__inner');
        if (inner) inner.classList.remove('is-empty');
      }

      // header cart icon/count bubble
      if (sections['cart-icon-bubble']) {
        var bDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var freshB = bDoc.querySelector('.shopify-section') || bDoc.body;
        var liveB = document.getElementById('cart-icon-bubble');
        if (freshB && liveB) liveB.innerHTML = freshB.innerHTML;
      }
    }
  });
})();
